import { create } from "zustand";

export type DeviceStatus =
  | "idle"            // not started (signed out or no calling permission)
  | "unsupported"     // browser lacks WebRTC / media devices
  | "connecting"      // fetching token / registering
  | "ready"           // can place calls (and receive, if registered)
  | "offline"         // unregistered or network lost
  | "error";

export type IncomingCall = { callSid: string; from: string; receivedAt: number };
export type SdkCallState = "connecting" | "ringing" | "open" | "reconnecting" | "closed";

type VoiceState = {
  status: DeviceStatus;
  error: string | null;
  identity: string | null;
  incomingAllowed: boolean;
  outgoingAllowed: boolean;
  registered: boolean;
  presence: "AVAILABLE" | "AWAY";
  incoming: IncomingCall[];
  activeCallSid: string | null;
  sdkCallState: SdkCallState | null;
  muted: boolean;
  callWarning: string | null;
  lastCallError: string | null;
  /** Server id of the most recent outbound call from this tab, used to explain why it ended. */
  lastOutboundCallId: string | null;
  set: (patch: Partial<Omit<VoiceState, "set">>) => void;
};

export const useVoice = create<VoiceState>((set) => ({
  status: "idle",
  error: null,
  identity: null,
  incomingAllowed: false,
  outgoingAllowed: false,
  registered: false,
  presence: "AVAILABLE",
  incoming: [],
  activeCallSid: null,
  sdkCallState: null,
  muted: false,
  callWarning: null,
  lastCallError: null,
  lastOutboundCallId: null,
  set: (patch) => set(patch),
}));
